/* Newchic Star theme JS — vanilla, no dependencies */
(() => {
  const N = window.NCS || { routes: {}, strings: {} };
  const R = N.routes, S = N.strings;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const root = (R.root || '/').replace(/\/?$/, '/');

  /* ---------- helpers ---------- */
  const formatMoney = (cents) => {
    const v = Math.round(Number(cents) || 0);
    if (N.currencyFormat === 'iqd_ar') return Math.round(v / 100).toLocaleString('en-US') + ' ' + (N.currencySymbol || 'د.ع');
    const fmt = N.moneyFormat || '{{amount}}';
    const num = (d, sep = ',', dec = '.') => { const p = (v / 100).toFixed(d).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep); return p.join(dec); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => ({ amount: num(2), amount_no_decimals: num(0), amount_with_comma_separator: num(2, '.', ','), amount_no_decimals_with_comma_separator: num(0, '.', ',') }[k] || num(2)));
  };
  N.formatMoney = formatMoney;
  let toastT;
  const toast = (msg) => { const t = $('[data-toast]'); if (!t) return; t.textContent = msg; t.classList.add('is-visible'); clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove('is-visible'), 2600); };
  const postJSON = (url, body) => fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(async (r) => { const j = await r.json(); if (!r.ok || j.status) throw new Error(j.description || j.message || S.cartError); return j; });
  const parseHTML = (html) => new DOMParser().parseFromString(html, 'text/html');

  /* ---------- overlay / drawers / modals ---------- */
  const overlay = $('[data-overlay]');
  const openStack = [];
  let lastFocus;
  const show = (el) => {
    if (!el) return;
    lastFocus = document.activeElement;
    el.hidden = false;
    requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('is-open')));
    openStack.push(el);
    overlay && overlay.classList.add('is-visible');
    document.body.classList.add('is-locked');
    setTimeout(() => { const f = el.querySelector('input[type=search], [data-drawer-close], [data-modal-close]'); f && f.focus({ preventScroll: true }); }, 80);
  };
  const hide = (el) => {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    const i = openStack.indexOf(el); if (i > -1) openStack.splice(i, 1);
    setTimeout(() => { if (!el.classList.contains('is-open')) el.hidden = true; }, 380);
    if (!openStack.length) { overlay && overlay.classList.remove('is-visible'); document.body.classList.remove('is-locked'); lastFocus && lastFocus.focus && lastFocus.focus({ preventScroll: true }); }
  };
  const drawer = (name) => $(`[data-drawer="${name}"]`);
  const modal = (name) => $(`[data-modal="${name}"]`);
  const openDrawer = (name) => { openStack.slice().forEach(hide); show(drawer(name)); };
  N.openCart = () => { if (N.cartType === 'page') { location.href = R.cart; return; } openDrawer('cart'); };
  overlay && overlay.addEventListener('click', () => openStack.slice().forEach(hide));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && openStack.length) hide(openStack[openStack.length - 1]); });

  /* ---------- cart ---------- */
  const updateCount = (count) => $$('[data-cart-count]').forEach((b) => { b.textContent = count; b.hidden = !count; });
  const renderCart = (sections) => {
    const html = sections && sections['cart-drawer'];
    if (!html) return;
    const fresh = parseHTML(html).querySelector('[data-cart-root]');
    const cur = $('#CartDrawer [data-cart-root]');
    if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    applyCheckoutDiscount();
  };
  const refreshCount = () => fetch(R.cart + '.js').then((r) => r.json()).then((c) => updateCount(c.item_count));
  const sectionsPayload = () => ({ sections: 'cart-drawer', sections_url: location.pathname });
  N.addItems = async (items) => {
    const res = await postJSON(R.cartAdd + '.js', Object.assign({ items }, sectionsPayload()));
    renderCart(res.sections);
    await refreshCount();
    return res;
  };
  const changeLine = async (line, quantity) => {
    const panel = $('#CartDrawer [data-cart-root]');
    panel && panel.classList.add('is-loading');
    try {
      const res = await postJSON(R.cartChange + '.js', Object.assign({ line, quantity }, sectionsPayload()));
      renderCart(res.sections); updateCount(res.item_count);
    } catch (e) { toast(e.message); } finally { panel && panel.classList.remove('is-loading'); }
  };
  const applyCheckoutDiscount = () => {
    const code = localStorage.getItem('ncs_discount');
    $$('[data-checkout]').forEach((a) => { a.href = root + 'checkout' + (code ? '?discount=' + encodeURIComponent(code) : ''); });
  };
  let noteT;
  document.addEventListener('input', (e) => {
    if (e.target.matches('[data-cart-note]')) { clearTimeout(noteT); noteT = setTimeout(() => postJSON(R.cartUpdate + '.js', { note: e.target.value }).catch(() => {}), 500); }
  });

  /* ---------- global click delegation ---------- */
  document.addEventListener('click', (e) => {
    const t = e.target;
    let el;
    if ((el = t.closest('[data-open-drawer]'))) { e.preventDefault(); openDrawer(el.dataset.openDrawer); return; }
    if ((el = t.closest('[data-open-cart]')) && N.cartType !== 'page') { e.preventDefault(); N.openCart(); return; }
    if ((el = t.closest('[data-drawer-close]'))) { e.preventDefault(); hide(el.closest('[data-drawer]')); return; }
    if ((el = t.closest('[data-open-modal]'))) { e.preventDefault(); show(modal(el.dataset.openModal)); return; }
    if ((el = t.closest('[data-modal-close]'))) { hide(el.closest('[data-modal]')); return; }
    if ((el = t.closest('[data-modal]')) && t === el) { hide(el); return; }
    if ((el = t.closest('[data-cart-qty]'))) { const li = el.closest('[data-line]'); changeLine(Number(li.dataset.line), Number(el.dataset.cartQty)); return; }
    if ((el = t.closest('[data-quick-view]'))) { e.preventDefault(); quickView(el.dataset.quickView); return; }
    if ((el = t.closest('[data-zoom]'))) { const m = modal('zoom'); if (m) { $('[data-zoom-img]', m).src = el.dataset.zoom; show(m); } return; }
    if (t.closest('[data-zoom-wrap] img')) { hide(modal('zoom')); return; }
    if ((el = t.closest('.swatch'))) {
      const card = el.closest('[data-product-card]');
      $$('.swatch', card).forEach((s) => s.classList.toggle('is-active', s === el));
      const img = card && $('.card__img-1', card);
      if (img && el.dataset.swatchImg) { img.removeAttribute('srcset'); img.src = el.dataset.swatchImg; }
      return;
    }
    if ((el = t.closest('[data-copy]'))) { navigator.clipboard && navigator.clipboard.writeText(el.dataset.copy); toast(S.copied); return; }
    if ((el = t.closest('[data-toggle-recover]'))) { e.preventDefault(); const a = $('[data-login-box]'), b = $('[data-recover-box]'); if (a && b) { a.hidden = !a.hidden; b.hidden = !b.hidden; } return; }
  });

  /* ---------- product form (variants) ---------- */
  class ProductForm {
    constructor(el) {
      this.el = el; el._pf = this;
      this.data = JSON.parse($('[data-product-json]', el).textContent);
      this.fieldsets = $$('[data-option-index]', el);
      this.selected = this.fieldsets.map((f) => { const s = $('.vbtn.is-selected', f); return s ? s.dataset.value : null; });
      this.idInput = $('[data-variant-id]', el);
      this.addBtn = $('[data-add-btn]', el);
      this.buyBtn = $('[data-buy-now]', el);
      this.label = $('[data-add-label]', el);
      this.stock = $('[data-stock]', el);
      this.error = $('[data-form-error]', el);
      this.scope = el.closest('.qv, [data-pdp]') || document;
      this.fieldsets.forEach((f, i) => f.addEventListener('click', (e) => { const b = e.target.closest('.vbtn'); if (!b) return; this.select(i, b.dataset.value); }));
      const form = $('form', el);
      form.addEventListener('submit', (e) => { e.preventDefault(); this.add(false); });
      this.buyBtn && this.buyBtn.addEventListener('click', () => this.add(true));
      const qty = $('[data-qty]', el);
      if (qty) { const inp = $('input', qty); qty.addEventListener('click', (e) => { if (e.target.closest('[data-qty-plus]')) inp.value = +inp.value + 1; if (e.target.closest('[data-qty-minus]')) inp.value = Math.max(1, +inp.value - 1); }); }
      this.update(false);
    }
    select(i, value) {
      this.selected[i] = value;
      const fs = this.fieldsets[i];
      $$('.vbtn', fs).forEach((b) => b.classList.toggle('is-selected', b.dataset.value === value));
      const lbl = $('[data-option-selected]', fs); if (lbl) lbl.textContent = value;
      this.update(true);
    }
    update(userAction) {
      const d = this.data;
      // availability marking
      this.fieldsets.forEach((fs, i) => {
        $$('.vbtn', fs).forEach((b) => {
          const ok = d.variants.some((v) => v.available && v.options[i] === b.dataset.value && this.selected.every((s, j) => j === i || s === null || v.options[j] === s));
          b.classList.toggle('is-unavailable', !ok);
        });
      });
      if (!this.fieldsets.length) { this.variant = d.variants[0]; } else {
        const complete = this.selected.every((s) => s !== null);
        this.variant = complete ? d.variants.find((v) => v.options.every((o, j) => o === this.selected[j])) : null;
      }
      const v = this.variant;
      const missing = this.fieldsets.length ? this.fieldsets.filter((f, i) => this.selected[i] === null).map((f) => $('legend span', f).textContent.split(':')[0].trim()) : [];
      let text = S.addToCart, disabled = false;
      if (!v && missing.length) { text = missing.length > 1 ? S.selectOptions : 'اختر ' + missing[0]; disabled = true; }
      else if (!v) { text = S.unavailable; disabled = true; }
      else if (!v.available) { text = S.soldOut; disabled = true; }
      this.addBtn.disabled = disabled; if (this.buyBtn) this.buyBtn.disabled = disabled;
      this.label.textContent = text;
      this.idInput.value = v ? v.id : '';
      if (this.stock) { this.stock.className = 'pform__stock'; this.stock.textContent = ''; if (v && v.available) { if (v.qty !== null && v.qty > 0 && v.qty <= 5) { this.stock.textContent = S.lowStock.replace('[count]', v.qty); this.stock.classList.add('is-low'); } else this.stock.textContent = S.inStock; } }
      if (v) {
        const wrap = $('[data-price-wrap]', this.scope);
        if (wrap) {
          $('[data-price]', wrap).textContent = formatMoney(v.price);
          const cmp = $('[data-compare-price]', wrap), badge = $('[data-sale-badge]', wrap), sale = v.compare > v.price;
          wrap.classList.toggle('price--sale', sale);
          if (cmp) { cmp.hidden = !sale; cmp.textContent = sale ? formatMoney(v.compare) : ''; }
          if (badge) { badge.hidden = !sale; badge.textContent = sale ? '-' + Math.round((v.compare - v.price) * 100 / v.compare) + '%' : ''; }
        }
        if (userAction && v.media) { const g = $('[data-gallery]', this.scope); g && g._gallery && g._gallery.goToMedia(v.media); }
        if (userAction && this.el.dataset.context === 'main') history.replaceState(null, '', this.el.dataset.url + '?variant=' + v.id);
      }
    }
    async add(buyNow) {
      if (!this.variant) { this.showError(this.label.textContent); return; }
      const btn = buyNow ? this.buyBtn : this.addBtn;
      btn.classList.add('is-loading'); this.showError('');
      const q = $('input[name=quantity]', this.el);
      try {
        await N.addItems([{ id: this.variant.id, quantity: q ? Math.max(1, +q.value) : 1 }]);
        if (buyNow) { location.href = root + 'checkout'; return; }
        const qv = this.el.closest('[data-modal]'); if (qv) hide(qv);
        toast(S.added);
        setTimeout(() => N.openCart(), qv ? 300 : 0);
      } catch (e) { this.showError(e.message); } finally { btn.classList.remove('is-loading'); }
    }
    showError(m) { if (!this.error) return; this.error.textContent = m; this.error.hidden = !m; }
  }

  /* ---------- gallery ---------- */
  class Gallery {
    constructor(el) {
      this.el = el; el._gallery = this;
      this.track = $('[data-gallery-track]', el);
      this.slides = $$('[data-gallery-track] > *', el);
      this.thumbs = $$('[data-thumb]', el);
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.go(+t.dataset.thumb)));
      const p = $('[data-gallery-prev]', el), n = $('[data-gallery-next]', el);
      p && p.addEventListener('click', () => this.go(this.index() - 1));
      n && n.addEventListener('click', () => this.go(this.index() + 1));
      let st; this.track && this.track.addEventListener('scroll', () => { clearTimeout(st); st = setTimeout(() => this.sync(), 80); }, { passive: true });
    }
    index() { const w = this.track.clientWidth || 1; return Math.round(Math.abs(this.track.scrollLeft) / w); }
    go(i) { if (!this.slides.length) return; i = (i + this.slides.length) % this.slides.length; const s = this.slides[i]; this.track.scrollTo({ left: s.offsetLeft - this.slides[0].offsetLeft, behavior: 'smooth' }); void s({ behavior: 'smooth', block: 'nearest', inline: 'start' }); this.mark(i); }
    goToMedia(id) { const i = this.slides.findIndex((s) => s.dataset.mediaId == id); if (i > -1) this.go(i); }
    sync() { this.mark(this.index()); }
    mark(i) { this.thumbs.forEach((t, j) => t.classList.toggle('is-active', j === i)); const a = this.thumbs[i]; a && a.scrollIntoView({ block: 'nearest', inline: 'nearest' }); }
  }

  /* ---------- quick view ---------- */
  const quickView = async (url) => {
    const m = modal('quick-view'); if (!m) return;
    const c = $('[data-modal-content]', m);
    c.innerHTML = '<div class="spinner"></div>';
    show(m);
    try {
      const r = await fetch(url + (url.includes('?') ? '&' : '?') + 'section_id=quick-view');
      const doc = parseHTML(await r.text());
      const qv = doc.querySelector('.qv');
      c.innerHTML = qv ? qv.outerHTML : '<p class="center">' + S.cartError + '</p>';
      init(c);
    } catch (e) { c.innerHTML = '<p class="center">' + S.cartError + '</p>'; }
  };

  /* ---------- sliders / rails / tabs / hotspots ---------- */
  const initSlider = (el) => {
    const slides = $$('[data-slide]', el), dots = $$('[data-slider-dot]', el);
    if (slides.length < 2) return;
    let i = 0, timer, paused = false;
    const delay = +el.dataset.autoplay * 1000;
    const go = (n) => { i = (n + slides.length) % slides.length; slides.forEach((s, j) => s.classList.toggle('is-active', j === i)); dots.forEach((d, j) => d.classList.toggle('is-active', j === i)); };
    const play = () => { clearInterval(timer); if (delay && !paused) timer = setInterval(() => go(i + 1), delay); };
    $('[data-slider-next]', el) && $('[data-slider-next]', el).addEventListener('click', () => { go(i + 1); play(); });
    $('[data-slider-prev]', el) && $('[data-slider-prev]', el).addEventListener('click', () => { go(i - 1); play(); });
    dots.forEach((d) => d.addEventListener('click', () => { go(+d.dataset.sliderDot); play(); }));
    const pb = $('[data-slider-pause]', el);
    pb && pb.addEventListener('click', () => { paused = !paused; pb.innerHTML = paused ? '<svg class="icon" viewBox="0 0 24 24"><path d="M8 5.5v13l10-6.5-10-6.5Z" fill="currentColor"/></svg>' : '<svg class="icon" viewBox="0 0 24 24"><path d="M9 6v12M15 6v12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>'; paused ? clearInterval(timer) : play(); });
    let x0 = null;
    el.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    el.addEventListener('touchend', (e) => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) { go(dx > 0 ? i + 1 : i - 1); play(); } x0 = null; });
    play();
  };
  const initAnnounce = (el) => {
    const msgs = $$('.announce__msg', el); if (msgs.length < 2) return;
    let i = 0; const go = (n) => { i = (n + msgs.length) % msgs.length; msgs.forEach((m, j) => m.classList.toggle('is-active', j === i)); };
    let t = setInterval(() => go(i + 1), (+el.dataset.autoplay || 4) * 1000);
    const reset = () => { clearInterval(t); t = setInterval(() => go(i + 1), (+el.dataset.autoplay || 4) * 1000); };
    $('[data-announce-next]', el).addEventListener('click', () => { go(i + 1); reset(); });
    $('[data-announce-prev]', el).addEventListener('click', () => { go(i - 1); reset(); });
  };
  const initRail = (wrap) => {
    const rail = $('[data-rail]', wrap); if (!rail) return;
    const step = () => rail.clientWidth * 0.8;
    const n = $('[data-rail-next]', wrap), p = $('[data-rail-prev]', wrap);
    n && n.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
    p && p.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
  };
  const initTabs = (el) => {
    const tabs = $$('[data-tab]', el), panels = $$('[data-tab-panel]', el);
    tabs.forEach((t) => t.addEventListener('click', () => { tabs.forEach((x) => { x.classList.toggle('is-active', x === t); x.setAttribute('aria-selected', x === t); }); panels.forEach((p) => { p.hidden = p.dataset.tabPanel !== t.dataset.tab; }); }));
  };
  const initLook = (el) => {
    const spots = $$('[data-hotspot]', el), items = $$('[data-hotspot-item]', el);
    spots.forEach((s) => s.addEventListener('click', () => { spots.forEach((x) => x.classList.toggle('is-active', x === s)); items.forEach((it) => it.classList.toggle('is-active', it.dataset.hotspotItem === s.dataset.hotspot)); const it = items.find((x) => x.dataset.hotspotItem === s.dataset.hotspot); it && it.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' }); }));
  };

  /* ---------- countdown ---------- */
  const initCountdown = (el) => {
    let end;
    if (el.dataset.evergreen === 'true') {
      const now = new Date(); const b = new Date(now.getTime() + 3 * 3600e3);
      end = Date.UTC(b.getUTCFullYear(), b.getUTCMonth(), b.getUTCDate() + 1) - 3 * 3600e3;
    } else {
      const m = (el.dataset.end || '').match(/(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/);
      if (!m) return;
      end = Date.UTC(+m[1], +m[2] - 1, +m[3], (+m[4] || 0) - 3, +m[5] || 0);
    }
    const f = (k) => $(`[data-cd="${k}"]`, el);
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      let d = Math.max(0, end - Date.now());
      if (d <= 0) { $$('.countdown__box', el).forEach((b) => (b.hidden = true)); const x = $('[data-cd-expired]', el); if (x && x.textContent.trim()) x.hidden = false; clearInterval(iv); return; }
      d = Math.floor(d / 1000);
      f('d').textContent = pad(Math.floor(d / 86400)); f('h').textContent = pad(Math.floor(d % 86400 / 3600)); f('m').textContent = pad(Math.floor(d % 3600 / 60)); f('s').textContent = pad(d % 60);
    };
    const iv = setInterval(tick, 1000); tick();
  };

  /* ---------- bundle builder / outfit ---------- */
  class Bundle {
    constructor(el) {
      this.el = el; this.mode = el.dataset.mode; this.max = +el.dataset.max || 0; this.discount = +el.dataset.discount || 0; this.code = el.dataset.code;
      this.items = $$('[data-bundle-item]', el);
      this.panel = $('[data-bundle-panel]', el);
      this.picked = [];
      this.items.forEach((it) => {
        const sel = $('[data-bundle-variant]', it);
        sel && sel.addEventListener('change', () => { this.syncPrice(it); this.render(); });
        const tog = $('[data-bundle-toggle]', it);
        tog && tog.addEventListener('click', () => this.toggle(it));
        const chk = $('[data-bundle-check]', it);
        chk && chk.addEventListener('change', () => { it.classList.toggle('is-selected', chk.checked); this.render(); });
      });
      $('[data-bundle-submit]', el).addEventListener('click', () => this.submit());
      const col = $('[data-bundle-collapse]', el); col && col.addEventListener('click', () => this.panel.classList.toggle('is-collapsed'));
      this.render();
    }
    syncPrice(it) { const sel = $('[data-bundle-variant]', it); const o = sel.tagName === 'SELECT' ? sel.selectedOptions[0] : sel; $('[data-bundle-price]', it).textContent = formatMoney(o.dataset.price); }
    variantOf(it) { const sel = $('[data-bundle-variant]', it); if (!sel) return null; const o = sel.tagName === 'SELECT' ? sel.selectedOptions[0] : sel; return sel.value ? { id: +sel.value, price: +o.dataset.price } : null; }
    toggle(it) {
      const i = this.picked.indexOf(it);
      if (i > -1) { this.picked.splice(i, 1); }
      else {
        if (!this.variantOf(it)) { toast(S.selectOptions); const s = $('select', it); s && s.focus(); return; }
        if (this.max && this.picked.length >= this.max) { toast(S.bundleFull); return; }
        this.picked.push(it);
      }
      this.render();
    }
    selected() { return this.mode === 'outfit' ? this.items.filter((it) => { const c = $('[data-bundle-check]', it); return c && c.checked; }) : this.picked; }
    render() {
      const sel = this.selected();
      this.items.forEach((it) => {
        const on = sel.includes(it); it.classList.toggle('is-selected', on);
        const tog = $('[data-bundle-toggle] span', it); if (tog) tog.textContent = on ? S.bundleAdded + ' ✓' : S.bundleAdd;
      });
      const slots = $('[data-bundle-slots]', this.panel);
      const n = this.max || sel.length;
      slots.innerHTML = '';
      for (let k = 0; k < n; k++) {
        const it = sel[k]; const d = document.createElement('div'); d.className = 'bslot';
        if (it) { d.innerHTML = `<img src="${it.dataset.img}" alt="">` + (this.mode === 'builder' ? '<button type="button" aria-label="x"><svg class="icon" viewBox="0 0 24 24"><path d="m6 6 12 12M18 6 6 18" stroke="currentColor" stroke-width="2"/></svg></button>' : ''); const b = $('button', d); b && b.addEventListener('click', () => this.toggle(it)); }
        else d.textContent = '+';
        slots.appendChild(d);
      }
      const total = sel.reduce((s, it) => s + ((this.variantOf(it) || {}).price || 0), 0);
      const ready = this.mode === 'outfit' ? sel.length > 0 : sel.length === this.max;
      const final = ready ? Math.round(total * (100 - this.discount) / 100) : total;
      const p = $('[data-bundle-progress]', this.panel); if (p) p.style.width = (this.max ? sel.length / this.max * 100 : 100) + '%';
      const orig = $('[data-bundle-original]', this.panel); orig.textContent = ready && this.discount ? formatMoney(total) : '';
      const sv = $('[data-bundle-saving]', this.panel); if (sv) sv.textContent = ready ? '-' + formatMoney(total - final) : '—';
      $('[data-bundle-final]', this.panel).textContent = formatMoney(final);
      const btn = $('[data-bundle-submit]', this.panel); btn.disabled = !ready;
      $('[data-bundle-submit-label]', this.panel).textContent = S.addBundle + ' · ' + formatMoney(final);
    }
    async submit() {
      const sel = this.selected(); const btn = $('[data-bundle-submit]', this.panel); const err = $('[data-bundle-error]', this.panel);
      const items = sel.map((it) => ({ id: this.variantOf(it).id, quantity: 1, properties: { '_bundle': this.code || 'bundle' } }));
      btn.classList.add('is-loading'); err.hidden = true;
      try {
        await N.addItems(items);
        if (this.code) {
          await fetch(root + 'discount/' + encodeURIComponent(this.code) + '?redirect=' + encodeURIComponent(R.cart + '.js'), { credentials: 'same-origin' }).catch(() => {});
          localStorage.setItem('ncs_discount', this.code); applyCheckoutDiscount();
          toast(S.discountApplied.replace('[code]', this.code));
        } else toast(S.added);
        if (this.mode === 'builder') { this.picked = []; this.render(); }
        N.openCart();
      } catch (e) { err.textContent = e.message; err.hidden = false; } finally { btn.classList.remove('is-loading'); }
    }
  }

  /* ---------- collection: filters, sort, load more, columns ---------- */
  const sectionEl = (id) => document.getElementById('shopify-section-' + id);
  const loadCollection = async (id, url, push = true) => {
    const sec = sectionEl(id); if (!sec) { location.href = url; return; }
    const res = $('[data-results]', sec); res && res.classList.add('is-loading');
    try {
      const u = new URL(url, location.origin); u.searchParams.set('section_id', id);
      const html = await (await fetch(u)).text();
      const fresh = parseHTML(html).getElementById('shopify-section-' + id) || parseHTML(html).body;
      sec.innerHTML = fresh.innerHTML;
      init(sec);
      if (push) { u.searchParams.delete('section_id'); history.pushState({ ncsSection: id }, '', u.pathname + u.search); }
    } catch (e) { location.href = url; }
  };
  window.addEventListener('popstate', (e) => { if (e.state && e.state.ncsSection) loadCollection(e.state.ncsSection, location.href, false); });
  const formToURL = (form) => {
    const fd = new FormData(form); const p = new URLSearchParams();
    for (const [k, v] of fd.entries()) if (v !== '') p.append(k, k.startsWith('filter.v.price') ? String(Math.round(+v)) : v);
    return location.pathname + '?' + p.toString();
  };
  const initCollection = (el) => {
    const id = el.dataset.sectionId;
    const form = $('[data-facets-form]', el);
    form && form.addEventListener('submit', (e) => { e.preventDefault(); hide(form.closest('[data-drawer]')); setTimeout(() => loadCollection(id, formToURL(form)), 200); });
    const sort = $('[data-sort]', el);
    sort && sort.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); loadCollection(id, u.pathname + u.search); });
    $$('[data-facet-link], [data-facet-clear]', el).forEach((a) => a.addEventListener('click', (e) => { e.preventDefault(); hide(a.closest('[data-drawer]')); loadCollection(id, a.getAttribute('href')); }));
    const more = $('[data-load-more]', el);
    more && more.addEventListener('click', async (e) => {
      e.preventDefault(); more.classList.add('is-loading');
      const u = new URL(more.href, location.origin); u.searchParams.set('section_id', id);
      const doc = parseHTML(await (await fetch(u)).text());
      const grid = $('[data-grid]', el);
      $$('[data-grid] > *', doc).forEach((c) => grid.appendChild(c));
      const nm = $('[data-load-more]', doc);
      if (nm) { more.href = nm.href; more.classList.remove('is-loading'); more.nextElementSibling && (more.nextElementSibling.textContent = nm.nextElementSibling ? nm.nextElementSibling.textContent : ''); } else more.parentElement.remove();
    });
    const grid = $('[data-grid]', el);
    if (grid) {
      const apply = (n) => { const mobile = innerWidth < 990; grid.style.setProperty(mobile ? '--cols-m' : '--cols-d', n); $$('[data-cols]', el).forEach((b) => b.classList.toggle('is-active', b.dataset.cols == n)); };
      const saved = localStorage.getItem(innerWidth < 990 ? 'ncs_cols_m' : 'ncs_cols_d');
      apply(saved || (innerWidth < 990 ? grid.dataset.defaultM : grid.dataset.defaultD) || 2);
      $$('[data-cols]', el).forEach((b) => b.addEventListener('click', () => { apply(b.dataset.cols); localStorage.setItem(innerWidth < 990 ? 'ncs_cols_m' : 'ncs_cols_d', b.dataset.cols); }));
    }
  };

  /* ---------- predictive search ---------- */
  const initPredictive = () => {
    const input = $('[data-predictive-input]'), out = $('[data-predictive-results]');
    if (!input || !out || !N.predictive) return;
    let t, ctrl;
    input.addEventListener('input', () => {
      clearTimeout(t); const q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      t = setTimeout(async () => {
        ctrl && ctrl.abort(); ctrl = new AbortController();
        try {
          const r = await fetch(`${R.predictive}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`, { signal: ctrl.signal });
          const j = await r.json(); const ps = (j.resources && j.resources.results.products) || [];
          out.innerHTML = ps.length ? '<div class="predictive__list">' + ps.map((p) => `<a class="predictive__item" href="${p.url}">${p.image ? `<img src="${p.image}" alt="" loading="lazy">` : ''}<span><strong>${p.title}</strong><br><span class="muted">${formatMoney(Math.round(parseFloat(p.price) * 100))}</span></span></a>`).join('') + `</div><a class="predictive__all" href="${R.search}?q=${encodeURIComponent(q)}&type=product">${'عرض كل النتائج'}</a>` : `<p class="muted center">لا توجد نتائج لـ "${q.replace(/</g, '')}"</p>`;
        } catch (e) {}
      }, 250);
    });
  };

  /* ---------- PDP sticky ATC + recommendations ---------- */
  const initSticky = (el) => {
    const bar = $('[data-sticky-atc]', el), btn = $('[data-add-btn]', el);
    if (!bar || !btn || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(([e]) => bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(btn);
    $('[data-sticky-atc-btn]', bar).addEventListener('click', () => { if (btn.disabled) btn.scrollIntoView({ behavior: 'smooth', block: 'center' }); else btn.click(); });
  };
  const initRecs = async (el) => {
    if (el.dataset.loaded) return; el.dataset.loaded = '1';
    try { const doc = parseHTML(await (await fetch(el.dataset.url)).text()); const f = doc.querySelector('[data-recommendations]'); if (f && f.innerHTML.trim()) { el.innerHTML = f.innerHTML; init(el); } } catch (e) {}
  };

  /* ---------- init ---------- */
  function init(scope = document) {
    $$('[data-product-form]', scope).forEach((el) => !el._pf && new ProductForm(el));
    $$('[data-gallery]', scope).forEach((el) => !el._gallery && new Gallery(el));
    $$('[data-slider]', scope).forEach((el) => { if (!el._i) { el._i = 1; initSlider(el); } });
    $$('[data-announce]', scope).forEach((el) => { if (!el._i) { el._i = 1; initAnnounce(el); } });
    $$('.rail-wrap', scope).forEach((el) => { if (!el._i) { el._i = 1; initRail(el); } });
    $$('[data-tabs]', scope).forEach((el) => { if (!el._i) { el._i = 1; initTabs(el); } });
    $$('[data-look]', scope).forEach((el) => { if (!el._i) { el._i = 1; initLook(el); } });
    $$('[data-countdown]', scope).forEach((el) => { if (!el._i) { el._i = 1; initCountdown(el); } });
    $$('[data-bundle]', scope).forEach((el) => { if (!el._i) { el._i = 1; new Bundle(el); } });
    $$('[data-collection]', scope).forEach((el) => { if (!el._i) { el._i = 1; initCollection(el); } });
    $$('[data-pdp]', scope).forEach((el) => { if (!el._i) { el._i = 1; initSticky(el); } });
    $$('[data-recommendations]', scope).forEach(initRecs);
  }
  N.init = init;
  const boot = () => {
    init(document); initPredictive(); applyCheckoutDiscount();
    const header = $('[data-header]');
    header && addEventListener('scroll', () => header.classList.toggle('is-scrolled', scrollY > 10), { passive: true });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
